import { AUTH_ENV, Environment } from '../../environments';
import { BRAND_CONFIG_COLLECTIONS } from '../config';
import { IS_HOYA_THEME, IS_SEIKO_THEME } from '../const';



export function getOtherBrandReroute( ) {

    if ( AUTH_ENV == Environment.PROD ) {return;}

    const route = window.location.href;

    const brandSpecs = BRAND_CONFIG_COLLECTIONS
        .find( b => b.environment == AUTH_ENV )
        .brands;

    const hoyaUrls = brandSpecs.find( b => b.name == 'hoya' ).brandIdentifiers;
    const seikoUrls = brandSpecs.find( b => b.name == 'seiko' ).brandIdentifiers;

    if ( IS_HOYA_THEME ) {
        const i = hoyaUrls.findIndex( u => route.includes( u ) );
        return seikoUrls[ i ];
    }

    if ( IS_SEIKO_THEME ) {
        const i = seikoUrls.findIndex( u => route.includes( u ) );
        return hoyaUrls[ i ];
    }

}